import { render, staticRenderFns } from "./AdminAlertsBanner.vue?vue&type=template&id=51dea4ca"
import script from "./AdminAlertsBanner.vue?vue&type=script&lang=js"
export * from "./AdminAlertsBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports